import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IHemoTechLicense } from 'app/models/licenses/hemo-tech/hemo-tech-license';
import { IHemoTechPublicRecord } from 'app/models/licenses/hemo-tech/hemo-tech-public-record';
import { ILicenseRequest } from 'app/models/licenses/license-request';

@Injectable({ providedIn: 'root' })
export class HemoTechLicenseService {
  private api: string = environment.privateApi + 'HemoTechLicense/';
  private publicApi: string = environment.publicApi + 'HemoTechReport/';

  private http = inject(HttpClient);

  public createLicense(isFull: boolean): Observable<IHemoTechLicense> {
    return this.http.post<IHemoTechLicense>(this.api + 'CreateLicense/' + isFull, null);
  }

  public getLicenses(): Observable<IHemoTechLicense[]> {
    return this.http.get<IHemoTechLicense[]>(this.api + 'GetLicenses');
  }

  public updateLicense(license: IHemoTechLicense): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  public submitLicense(license: IHemoTechLicense): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'SubmitLicense', license);
  }

  public renewLicense(licenseId: number, toFull: boolean, isLate: boolean): Observable<IHemoTechLicense> {
    return this.http.post<IHemoTechLicense>(this.api + 'RenewLicense/' + licenseId + '/' + toFull + '/' + isLate, null);
  }

  public cancelLicense(licenseId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'CancelLicense/' + licenseId);
  }

  public checkIfLicenseExists(licenseNumber: string): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'CheckIfLicenseExists/' + licenseNumber);
  }

  public requestLicense(licenseRequest: ILicenseRequest): Observable<number>{
    return this.http.post<number>(this.api + 'RequestLicense', licenseRequest);
  }

  public getLicenseRequests(): Observable<ILicenseRequest[]>{
    return this.http.get<ILicenseRequest[]>(this.api + 'GetLicenseRequests');
  }

  public cancelLicenseRequest(licenseRequestId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'CancelLicenseRequest/' + licenseRequestId);
  }

  public setAsStarted(licenseId: number): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'SetAsStarted/' + licenseId, null);
  }

  public getPublicRecords(): Observable<IHemoTechPublicRecord[]> {
    return this.http.get<IHemoTechPublicRecord[]>(this.publicApi + 'GetPublicRecords');
  }

  public setExpirationDate(licenseId: number, expirationDate: string): Observable<boolean>{
    const payload = { date: expirationDate };
    return this.http.post<boolean>(this.api + 'SetExpirationDate/' + licenseId, payload);
  }
}
